module.exports = __webpack_public_path__ + "static/media/no-trygg-ehandel.109d5cc9.png";